import React from 'react';
import Low from '@assets/icons/036-low.svg';
import PrognosisImg from '@assets/images/prognosis-img.png';

const ProactiveIdentificationGuidance = () => {
  return (
    <div className="mt-5 md:mt-10">
      <details className="govuk-details">
        <summary className="govuk-details__summary">
          <span className="govuk-details__summary-text">
            Learn about GSF Proactive Indicator Guidance
          </span>
        </summary>
        <div className="govuk-details__text">
          <div className="flex items-center mb-5 md:mb-10">
            <img src={Low} alt={Low} width={30} className="mr-2" />
            <h3 className="govuk-heading-s mt-5 planed-review-date">
              GSF Proactive Indicator Guidance (PIG)
            </h3>
          </div>
          <img
            src={PrognosisImg}
            alt={PrognosisImg}
            className="md:w-2/3 mb-5 md:mb-10"
          />
          <h3 className="govuk-heading-s">PIG -Early Identification Tool</h3>
          <p className="govuk-body">
            Identifying patients’ decline earlier enabling more proactive care.
            The GSF Proactive Identification Guidance (formerly known as the
            Prognostic Indicator Guidance) was developed in 2004 to enable GPs
            and other clinicians to improve earlier identification of patients
            on the last year or so of life.
          </p>
          <p className="govuk-body">
            It is a key tool used within the Gold Standards Framework (GSF)
            Quality Improvements Training Programmes to support earlier
            identification of patients, enabling better assessment of their
            needs and planning care in line with their needs and wishes.
          </p>
          <p className="govuk-body">
            This PIG guidance aims to clarify the triggers that help to identify
            patients earlier, in order that care can be better planned, more
            proactive, anticipate patients’ needs and take into account their
            own wishes following a discussion of their choices and preferences
            (advance care planning discussion).
          </p>
          <p className="govuk-body">
            These patients should be included on a supportive/palliative care
            register in their GP practice, care home or hospital and in many
            areas these patients are included on a locality register (digital
            shared information record) or EpaCCS.
          </p>
          <p className="govuk-body">
            Further details can be found here:{' '}
            <a
              href="https://www.gsfinternational.org.uk/pig-tool"
              className="govuk-link"
              rel="noreferrer noopener"
              target="_blank"
            >
              https://www.gsfinternational.org.uk/pig-tool
            </a>
          </p>
        </div>
      </details>
    </div>
  );
};

export default ProactiveIdentificationGuidance;
